// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfISOWeekYear as fn } from "../startOfISOWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfISOWeekYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default startOfISOWeekYearWithOptions;
